module.exports = __webpack_public_path__ + "img/remote-here-to-stay.cba6ad07.png";